module.exports = __webpack_public_path__ + "img/contact-icon-2.df65b941.png";